/**
 * compiler-status.js
 * -----------------------------------------------------------------------
 * "Choose a Device" listesindeki kartlarda, o cihaz için WASM derleyicinin
 * bu tarayıcıda daha önce başarıyla yüklenip yüklenmediğini göstermek için
 * kullanılır. localStorage GUI ve VM arasında (aynı origin) paylaşıldığı
 * için, buradaki anahtar adları openblock-vm/src/io/web-compiler/
 * compiler-bridge.js'in yazdığı anahtarlarla BİREBİR aynı olmalı.
 */

const STORAGE_PREFIX = 'ob_compiler_ready_'; // + 'avr' | 'esp32'

// deviceId -> hangi WASM pipeline'ı kullanıyor. compiler-bridge.js'deki
// FQBN_MAP ile aynı kapsamda tutulmalı — yalnızca gerçekten desteklenen
// cihazlar için bir rozet gösteriyoruz, diğerleri için hiçbir şey (null).
const DEVICE_COMPILER_KIND = {
    arduinoUno: 'avr',
    arduinoNano: 'avr',
    arduinoMega2560: 'avr',
    arduinoLeonardo: 'avr',
    arduinoEsp32: 'esp32'
};

/** @param {string} deviceId @returns {'avr'|'esp32'|null} */
export const getCompilerKindForDevice = deviceId => DEVICE_COMPILER_KIND[deviceId] || null;

/** @param {'avr'|'esp32'} kind @returns {boolean} */
export const isCompilerReady = kind => {
    try {
        return window.localStorage.getItem(STORAGE_PREFIX + kind) === '1';
    } catch (e) {
        return false; // localStorage kapalı/erişilemez olabilir (gizli sekme vb.)
    }
};

/**
 * Bir cihaz kartı için rozet durumu: 'ready' | 'not-ready' | null
 * (null = bu cihaz için WASM derleyici entegrasyonu yok, rozet gösterme).
 */
export const getDeviceCompilerBadgeStatus = deviceId => {
    const kind = getCompilerKindForDevice(deviceId);
    if (!kind) return null;
    return isCompilerReady(kind) ? 'ready' : 'not-ready';
};
